export enum MessageChannelType {
  Account = 'Account',
  ShipmentOrder = 'Shipment Order',
  Task = 'Task',
  Invoice = 'Invoice',
}
